import { useRef } from 'react';
import { TabSelectorOptionProps } from './TabSelectorOption.typed';
import * as Styled from './TabSelectorOption.styled';
import type { ChangeEvent } from 'react';

const TabSelectorOption = (props: TabSelectorOptionProps) => {
  const {
    hasError = false,
    disabled = false,
    selected = false,
    value,
    children,
    onClick,
    name,
  } = props;

  const contentRef = useRef<HTMLDivElement>(null);

  const scrollTabIntoView = () => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
      });
    }
  };

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    onClick && onClick(event.target.value);
    scrollTabIntoView();
  }

  return (
    <Styled.TabSelectorOption
      ref={contentRef}
      hasError={hasError}
      disabled={disabled}
    >
      <Styled.TabLabel
        htmlFor={value}
        selected={selected}
        aria-checked={selected}
        hasError={hasError}
      >
        <Styled.TabInput
          type="radio"
          name={name}
          id={value}
          value={value}
          checked={selected}
          onChange={handleChange}
        />
        <Styled.Content>{children}</Styled.Content>
      </Styled.TabLabel>
    </Styled.TabSelectorOption>
  );
};

export { TabSelectorOption };
